<div class="nf-wrapper">
  <div class="nf-card">
    <div class="nf-code">404</div>
    <div class="nf-divider"></div>
    <h1 class="nf-title">Page Not Found</h1>
    <p class="nf-desc">
      The page you're looking for doesn't exist or may have been moved.
    </p>
    <button class="nf-btn" (click)="goHome()">
      <i class="pi pi-home"></i>&nbsp; Go to Dashboard
    </button>
  </div>
</div>
